var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_3608_48936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6134 11.7136H15.6634V11.6636V10.9387V10.8887H15.6134H9.7644H9.7144V10.9387V11.6636V11.7136H9.7644H15.6134Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M30.2362 11.7136H30.2862V11.6636V10.9387V10.8887H30.2362H24.7527H24.7027V10.9387V11.6636V11.7136H24.7527H30.2362Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.2563 10.819L25.2649 10.7902L25.2436 10.7691L20.0349 5.60512L19.9997 5.57022L19.9645 5.60512L14.7558 10.7691L14.7345 10.7902L14.7431 10.819L19.9518 28.1583L19.9997 28.3177L20.0476 28.1583L25.2563 10.819ZM19.9997 6.73612L24.3268 11.0261L19.9997 25.4306L15.6726 11.0261L19.9997 6.73612Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.0484 11.4547L23.055 11.4292L23.0377 11.4093L20.0377 7.96715L20 7.9239L19.9623 7.96715L16.9623 11.4093L16.945 11.4292L16.9516 11.4547L19.9516 23.0126L20 23.199L20.0484 23.0126L23.0484 11.4547ZM20 21.1082L17.5302 11.5932L20 8.75939L22.4698 11.5932L20 21.1082Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M28.2254 10.7337L28.2359 10.7038L28.2134 10.6815L20.0348 2.57314L19.9996 2.53823L19.9644 2.57314L11.7858 10.6815L11.7634 10.7038L11.7739 10.7337L19.9525 33.9122L19.9996 34.0458L20.0468 33.9122L28.2254 10.7337ZM19.9996 3.70414L27.2787 10.9208L19.9996 31.5501L12.7205 10.9208L19.9996 3.70414Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M30.9194 10.8634L30.9307 10.8332L30.9077 10.8104L20.0349 0.0308989L19.9997 -0.00400182L19.9645 0.030899L9.09175 10.8104L9.06881 10.8332L9.08012 10.8634L19.9529 39.9508L19.9997 40.0761L20.0466 39.9508L30.9194 10.8634ZM19.9997 1.16192L29.9659 11.0426L19.9997 37.7048L10.0336 11.0426L19.9997 1.16192Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M19.584 6.22656V6.27656H19.634H20.3652H20.4152V6.22656V0.427734V0.377734H20.3652H19.634H19.584V0.427734V6.22656Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M19.584 38.4827V38.5327H19.634H20.3652H20.4152V38.4827V26.1602V26.1102H20.3652H19.634H19.584V26.1602V38.4827Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3608_48936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKite);
export default __webpack_public_path__ + "static/media/kite.80ab2b2522ee5ca509b2a9901a68f32c.svg";
export { ForwardRef as ReactComponent };